import { toast } from "react-toastify";
import { executePost } from "../ServiceMethods";
import { SessionTimeout } from "../ErrorMessages";
import { removeUserCredentials } from "../LocalStorage";

export const CancelMarketplaceReqApi = async (data, cb) => {
  try {
    const CancelMarketplaceReqApi = await executePost(
      "/businessuser/cancel_marketplace_request",
      data
    );
    const CancelMarketplaceReqApiData = CancelMarketplaceReqApi.data
      ? CancelMarketplaceReqApi.data
      : [];
    return CancelMarketplaceReqApiData;
  } catch (error) {
    if (error.response.data.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();
      toast.error(SessionTimeout, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      removeUserCredentials();
      if (cb) {
        cb();
      }
    } else {
      return false;
    }
  }
};
